import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { openSubscriptionModal } from "app/pages/benchmark-tracker/store/actions/report";
import { selectIsReportLoaded } from "app/pages/benchmark-tracker/store/selectors/reportSelectors";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const useOpenModalFromUrl = () => {
    const isReportLoaded = useSelector(selectIsReportLoaded);
    const dispatch = useDispatch();
    const { modal } = proNavigator.getParams();

    useEffect(() => {
        if (!modal || !isReportLoaded) {
            return;
        }

        if (modal === "subscription") {
            dispatch(openSubscriptionModal());
        }

        proNavigator.updateParams({ modal: undefined }, { location: "replace" });
    }, [modal, isReportLoaded]);
};
